import {Injectable, Injector} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {BehaviorSubject, Observable, ObservableInput, throwError as observableThrowError} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {NotifyService} from '../../brover-notify/services/notify.service';
import {environment} from '../../../../environments/environment';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';


@Injectable()
export class ErrorInterceptorService  implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private notify: NotifyService, private http: HttpClient, private injector: Injector,
              private localStorageService: LocalStorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse, caught): ObservableInput<any> => {
        if (err.status !== 401) {
          return observableThrowError(err);
        } else {
          if (this.refreshTokenInProgress) {
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(() => next.handle(this.addAuthenticationToken(req)))
            );
          } else {
            this.refreshTokenInProgress = true;
            this.refreshTokenSubject.next(null);
            return this.refreshAccessToken().pipe(
              switchMap((token: any) => {
                this.refreshTokenInProgress = false;
                this.refreshTokenSubject.next(token);

                return next.handle(this.addAuthenticationToken(req));
              }));
          }
        }
      })
    );
  }

  private refreshAccessToken(): Observable<any> {
    const token: string = this.localStorageService.get('refresh-token');
    const result = token.split(' ');

    const data = {
      grant_type: 'refresh_token',
      refresh_token: result[1],
      redirect_uri: environment.redirectUri
    };
    return this.http.post(`${environment.auth_api}auth/token`, data).pipe(
      tap((response: {token_type: string, access_token: string, refresh_token: string}) => {
        if (response.hasOwnProperty('access_token') && response.hasOwnProperty('refresh_token')) {
          this.localStorageService.set('access-token', `${response.token_type} ${response.access_token}`);
          this.localStorageService.set('refresh-token', `${response.token_type} ${response.refresh_token}`);
        }
      }));

  }

  private addAuthenticationToken(request) {
    const accessToken = this.localStorageService.get('access-token');
    if (!accessToken) {
      return request;
    }
    return request.clone({
      setHeaders: {
        Authorization: this.localStorageService.get('access-token')
      }
    });
  }
}
